import { App } from '../App';

export const phoneSanitizer = (value: string) =>
  value
    .trim()
    .replace(/[^0-9+]/g, '')
    .replace(App.config.phoneCountryCode, '');

export const spacesSanitizer = (value: string) => value.replace(/\s/g, '');
